export const ECO_MODE = '0x01';
export const PERFORMANCE_MODE = '0x00';
